import React from 'react';
import { Share2, Sparkles, Video, Target, TrendingUp, Star } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { aboutData } from '../data/mock';

const iconMap = {
  Share2: Share2,
  Sparkles: Sparkles,
  Video: Video,
  Target: Target,
  TrendingUp: TrendingUp,
  Star: Star
};

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-6">
            {aboutData.title}
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed">
            {aboutData.description}
          </p>
        </div>

        {/* Services Grid - First Row (3 services) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-16">
          {aboutData.services.slice(0, 3).map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-slate-200 hover:border-red-300 bg-gradient-to-br from-white to-slate-50"
                style={{
                  animationDelay: `${index * 100}ms`
                }}
              >
                <CardContent className="p-8 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-red-600 to-red-700 mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-red-500/30">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Services Grid - Second Row (3 services) */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 mt-8">
          {aboutData.services.slice(3, 6).map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-slate-200 hover:border-red-300 bg-gradient-to-br from-white to-slate-50"
                style={{
                  animationDelay: `${(index + 3) * 100}ms`
                }}
              >
                <CardContent className="p-8 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-gradient-to-br from-red-600 to-red-700 mb-6 group-hover:scale-110 transition-transform duration-300 shadow-lg shadow-red-500/30">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>
                  <h3 className="text-xl font-bold text-slate-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-slate-600 leading-relaxed">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Bottom Accent */}
        <div className="mt-20 flex justify-center">
          <div className="h-1 w-32 bg-gradient-to-r from-red-600 to-red-700 rounded-full"></div>
        </div>
      </div>
    </section>
  );
};

export default About;
